'use client'

import Image from 'next/image'
import type { ScheduleItem } from '../../schedule'
import { performers, scheduleHosts } from '../../performers'
import { getVisibleConventionPerformers } from '../../../performerLaunches'
import { useSearchParams } from 'next/navigation'

export const EventList = ({ events }: DailyEvents) => {
  const searchParams = useSearchParams()
  const hideYouth = searchParams.get('hideYouth') === 'true'
  const performersByTag = new Map(
    [...getVisibleConventionPerformers(performers), ...scheduleHosts].flatMap(
      performer =>
        performer.magicianSlug
          ? [[`performer:${performer.magicianSlug}`, performer] as [string, typeof performer]]
          : []
    )
  )

  const filteredEvents = hideYouth
    ? events.filter(item => !item.tags?.includes('youth'))
    : events

  return (
    <tbody>
      {filteredEvents.map(item => {
        const eventPerformers = (item.tags ?? []).flatMap(tag => {
          const performer = performersByTag.get(tag)
          return performer ? [performer] : []
        })

        return (
          <tr key={item.id} className="border-b border-gray-300">
            <th className="w-1/5 text-left text-xl py-4 pr-4 align-top">
              {item.time}
            </th>
            <td className="py-4">
              <div
                className={
                  eventPerformers.length === 1
                    ? 'flex flex-col gap-2 sm:flex-row sm:items-start sm:gap-3'
                    : undefined
                }
              >
                {eventPerformers.length > 0 && (
                  <div
                    className={`flex flex-wrap gap-1.5 ${eventPerformers.length === 1 ? 'shrink-0' : 'mb-2'}`}
                  >
                    {eventPerformers.map(performer => (
                      <Image
                        key={performer.magicianSlug}
                        src={`${performer.image}?w=40&dpr=2`}
                        alt={performer.alt}
                        title={performer.name}
                        width={40}
                        height={40}
                        sizes="(max-width: 639px) 32px, 40px"
                        unoptimized
                        className="size-8 shrink-0 rounded-full border border-gray-200 object-cover object-top sm:size-10"
                      />
                    ))}
                  </div>
                )}
                <div className="min-w-0">
                  <h3 className="text-xl font-semibold mb-1">{item.title}</h3>
                  {item.description && (
                    <p className="whitespace-pre-line text-gray-700">
                      {item.description}
                    </p>
                  )}
                </div>
              </div>
            </td>
          </tr>
        )
      })}
    </tbody>
  )
}

interface DailyEvents {
  events: ScheduleItem[]
}
